/**
 * Odds-filter chip — OP per-source visibility for the comparison column
 * (Dan 2026-08-23; placement revised same day: lives DISCREETLY in the
 * table's own title bar, not the global toolbar — the chip governs THIS
 * table's columns, and the toolbar is board-global controls. Styled small +
 * quiet on purpose: an advanced-user control). The Unabated "U" chip was
 * retired with that channel (#1192).
 *
 * Self-contained: reads/writes displaySettings directly so any hosting
 * table gets the control without prop plumbing. The SETTING remains global
 * — flipping the chip here changes every odds surface, exactly as before.
 */
import { cn } from '@/lib/infra/utils';
import { useDisplaySettings } from '@/stores/displaySettings';

export function OddsFilterChips() {
  const showOpOdds = useDisplaySettings((s) => s.showOpOdds);
  const setShowOpOdds = useDisplaySettings((s) => s.setShowOpOdds);
  return (
    <div className="flex items-center gap-1" aria-label="Odds columns">
      <span className="text-muted-foreground/50 pr-0.5 text-[9px] font-semibold uppercase tracking-wide">
        Odds
      </span>
      <button
        type="button"
        onClick={() => setShowOpOdds(!showOpOdds)}
        aria-pressed={showOpOdds}
        title="OddsPapi comparison column (OP/PNCL) — de-vigged consensus / Pinnacle fair values."
        className={cn(
          'rounded px-1.5 py-0.5 text-[10px] font-semibold transition-colors',
          showOpOdds
            ? 'bg-primary/80 text-primary-foreground'
            : 'text-muted-foreground/60 hover:text-foreground',
        )}
      >
        OP
      </button>
    </div>
  );
}
